<i18n
  src="@/locales/views/packing_house/process/exec_steps/list_processes.yml"
  lang="yaml"
></i18n>

<template>
  <bread-crumbs :labels="[module_name]"></bread-crumbs>

  <div class="bg-white shadow overflow-hidden sm:rounded-md" v-if="load_data">
    <ul role="list" class="divide-y divide-gray-200">
      <li
        v-for="packing_house_process in packing_house_processes"
        :key="packing_house_process.id"
      >
        <div
          href="#"
          class="block hover:bg-gray-50 cursor-pointer"
          @click.prevent="goToShowProcess(packing_house_process)"
        >
          <div class="px-4 py-4 sm:px-6">
            <div class="flex items-center justify-between">
              <p class="text-sm font-medium text-gray-900 truncate">
                {{ packing_house_process.name }}
              </p>
              <div class="ml-2 flex-shrink-0 flex">
                <a
                  class="link"
                  @click.prevent="goToShowProcess(packing_house_process)"
                >
                  <i class="fa-solid fa-pen"></i>
                  <span class="space-icon"></span>
                  {{ $t("labels.manage_link") }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>

  <loading-message v-else />
  <div></div>
</template>

<script>
import Requester from "@/views/packing_house/requesters/process/exec_steps/list_processes.js";

export default {
  name: "PHProcessExecStepsListProcesses",
  data() {
    return {
      packing_house_processes: [],
      load_data: false,
    };
  },
  props: {
    packing_house_id: {
      required: true,
    },
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          packing_house_id: this.packing_house_id,
        },
      }).then(() => this.fetchListProcesses())
    );
  },
  methods: {
    fetchListProcesses: async function () {
      let response = await Requester.fetchPackingHouseProcesses(
        this.packing_house_id
      );
      this.packing_house_processes = response.data;
      this.load_data = true;
    },
    goToShowProcess: function (packing_house_process) {
      this.$router.push({
        name: this.routeName("show_process"),
        params: {
          packing_house_id: this.packing_house_id,
          packing_house_process_id: packing_house_process.id,
        },
      });
    },
  },
};
</script>
